import { createFileRoute } from '@tanstack/react-router';
import { PageCarte } from '../carte/PageCarte';
import { type CarteRecherche, carteRechercheSchema, rechercheVersUrl } from '../carte/recherche-url';

// Mise en page sans chemin, commune à `/` et `/clients/$id` : la carte y est montée une seule fois.
// Filtres, vue et cadrage vivent dans l'URL et partagent le schéma zod de l'API (SPEC 8).
export const Route = createFileRoute('/_carte')({
  validateSearch: carteRechercheSchema,
  search: {
    // Le routeur réécrit l'URL avec la recherche validée, valeurs par défaut comprises
    // (`actifs=true`, `vue=carte`, `rayon=5` sans périmètre) : on les retire après validation.
    middlewares: [({ search, next }) => rechercheVersUrl(next(search) as CarteRecherche) as CarteRecherche],
  },
  component: PageCarte,
});
